/* eslint-disable no-undef */
// eslint-disable-next-line import/prefer-default-export

const Attribute = async (key, value) => {
  switch (key) {
    case 'gender':
      Moengage.add_gender(value);
      break;
    case 'employment_status':
      Moengage.add_user_attribute('employment_status', value);
      break;
    case 'marital_status':
      Moengage.add_user_attribute('marital_status', value);
      break;
    case 'monthly_income':
      Moengage.add_user_attribute('monthly_income', value);
      break;
    case 'office_pincode':
      Moengage.add_user_attribute('office_pincode', value);
      break;
    case 'pincode':
      Moengage.add_user_attribute('pincode', value);
      break;
    case 'pan_number':
      Moengage.add_user_attribute('pan_number', value);
      break;
    case 'first_name':
      Moengage.add_first_name(value);
      break;
    case 'last_name':
      Moengage.add_last_name(value);
      break;
    case 'email':
      Moengage.add_email(value);
      break;
    case 'mobile':
      Moengage.add_mobile(value);
      break;
    case 'dob':
      Moengage.add_birthday(value);
      break;
    case 'company_name':
      Moengage.add_user_attribute('company_name', value);
      break;
    case 'office_city':
      Moengage.add_user_attribute('office_city', value);
      break;
    case 'current_city':
      Moengage.add_user_attribute('city', value);
      break;
    case 'current_state':
      Moengage.add_user_attribute('state', value);
      break;
    default:
      break;
  }
};

export default Attribute;
